import script from "./esDoctorItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./esDoctorItem.vue?vue&type=script&setup=true&lang=ts"

import "./esDoctorItem.vue?vue&type=style&index=0&id=3b0a89c8&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0a89c8"]])

export default __exports__